import type { PortfolioImportMapping } from '@workspace/types';

export type DebtSource = 'EXCEL' | 'SETUP';

const REQUIRED: Array<keyof PortfolioImportMapping> = ['invoiceNumber', 'amount', 'dueDate'];

/** Columnas obligatorias que el reconocimiento automático no encontró. */
export function missingImportFields(mapping: PortfolioImportMapping): Array<keyof PortfolioImportMapping> {
  const missing = REQUIRED.filter(key => !mapping[key]?.trim());
  if (!mapping.phone?.trim() && !mapping.email?.trim()) {
    missing.unshift('phone');
  }
  return missing;
}

export function defaultAgentName(companyName: string): string {
  const name = companyName.trim();
  return name ? `Cobranzas ${name}` : 'Cobranzas';
}
